export default function MoreIcon() {
  return (
    <svg className="h-full fill-current" viewBox="0 0 24 24">
      <path d="M15.77 10.62l-2.71-2.71a1 1 0 011.4-1.42l4.37 4.37a1 1 0 010 1.42l-4.36 4.36a1 1 0 01-1.41-1.41l2.59-2.6H4.7a1 1 0 010-2h11.07v-.01z" />
    </svg>
  );
}
